import React, { FC, useRef } from 'react';
import listImgWidget from '../../../../assets/images/dashboard/edit-widet.png'

import { Link } from 'react-router-dom';
import {  base_url_widget, getEnvAccordingToHostName, nameOfWidget } from '../../../../utils/env';

interface DataWidget {
    widgetId: string
    name: string
    companyId: string;
    onClickDelete: (widgetId: string, companyId: string) => void;
    masterId:string
}






const ListWidget: FC<DataWidget> = (props: DataWidget) => {
    const { name, companyId, widgetId, onClickDelete,masterId } = props
    const iFrameCodeRef = useRef(null);
   

    

    const onClick = (companyIdd: string) => {
        console.log(companyIdd)
    }
    let selectedEnv = '';
    let environment = getEnvAccordingToHostName();
    if(environment.includes('-')) {
      selectedEnv = environment.substring(1);  //environments are listed as -[dev|qa|uat]; prod is ''
    }
    return (
        <div key={companyId} className="mt-5 md:w-1/5  m-3 md:m-0 flex flex-col md:mr-5">
            <img src={listImgWidget} alt="" className="box-shadow" />
            <p className="customListWidget text-md md:text-md mb-1 mt-1">{name}</p>
            <div className="relative code-snippet box-shadow">
                <p className="code-iframe-data" ref={iFrameCodeRef} >
                    &lt;script
                    id=&quot;successware-customer-link-widget&quot;
                    env=&quot;{selectedEnv}&quot;
                  companyId=&quot;{companyId}&quot;
                  widgetId=&quot;{widgetId}&quot;
                  masterId=&quot;{masterId}&quot;
                  src=&quot;{base_url_widget}widget/{nameOfWidget}?v=1.0.0&quot;&gt;
                    &lt;/script&gt;
                </p>
            </div>
            <div className="flex flex-row" >
                <button className="font-bold text-customBlue btn-delete-list-widget mt-3 mb-1 md:mr-2"
                    onClick={() => onClickDelete(widgetId, companyId)}>
                    Delete
                </button>
                <Link className="" to={`/admin/widget/edit?widgetId=${widgetId}&companyId=${companyId}`}>
                    <button
                        className="font-bold text-customBlue btn-edit-list-widget mt-3 mb-1"
                        onClick={() => onClick(companyId)}
                    >Edit</button>
                </Link>
            </div>

        </div>
    )
}

export default ListWidget;